import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../../components/Header/Header";

const AboutUsPage = () => {
  const [aboutUsContent, setAboutUsContent] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAboutUsContent = async () => {
      try {
        const response = await axios.get(
          "https://auth.ssccglpinnacle.com/api/footer"
        );

        if (response.data && response.data.length > 0) {
          setAboutUsContent(response.data[0].about_us || "");
        } else {
          setError("Failed to load About Us content");
        }
      } catch (error) {
        console.error("Error fetching About Us content:", error);
        setError("An error occurred while fetching About Us content");
      } finally {
        setLoading(false);
      }
    };

    fetchAboutUsContent();
  }, []);

  return (
    <>
      <Header />

      <div className="min-h-screen bg-[#F9F9F9] px-4 md:px-12 py-8 text-gray-800">
        {/* <h1 className="text-2xl md:text-3xl font-bold text-center mb-6">
          About Us
        </h1> */}

        {loading && (
          <div className="flex justify-center items-center min-h-[200px]">
            <img
              src="/Bubble-Preloader.gif"
              alt="Loading..."
              className="w-12 h-12"
            />
          </div>
        )}

        {error && (
          <p className="text-red-600 text-center font-medium">{error}</p>
        )}

        {!loading && !error && (
          <div
            className="prose prose-sm md:prose-base max-w-none text-left leading-relaxed"
            dangerouslySetInnerHTML={{ __html: aboutUsContent }}
          />
        )}
      </div>
    </>
  );
};

export default AboutUsPage;
